import { addUserOrgSpace } from './Decorators.es6';
import { pickBy, identity } from 'lodash';

export default addUserOrgSpace((_, data) => {
  return {
    data: pickBy(
      {
        to_state: data.state,
        to_state_params: data.params,
        from_state: data.fromState,
        from_state_params: data.fromStateParams
      },
      identity
    )
  };
});



// WEBPACK FOOTER //
// ./src/javascripts/analytics/snowplow/transformers/PageView.es6.js